import {
    DashboardOutlined,
    ExportOutlined,
    ImportOutlined,
    SwapOutlined,
    TagOutlined,
} from '@ant-design/icons';
import { Layout, Menu, MenuProps } from 'antd';
import React, { useState } from 'react';
import { LazyImage } from './controls/LazyImage';
import { navigate } from "./routes/AnimatedRoutes";

const { Sider } = Layout;

export type MenuItem = Required<MenuProps>['items'][number];

export function LeftMenu(props: {}) {
    const [collapsed, setCollapsed] = useState(false);
    function getItem(
        label: React.ReactNode,
        key: React.Key,
        icon?: React.ReactNode,
        children?: MenuItem[],
        onClick?: () => any
    ): MenuItem {
        return {
            key,
            icon,
            children,
            label,
            onClick
        } as MenuItem;
    }

    let key = 1;
    function getKey() {
        return `${key++}`;
    }

    const items: MenuItem[] = [
        getItem('Dashboard', getKey(), <DashboardOutlined />, undefined, () => navigate('/')),
        getItem('Import', getKey(), <ImportOutlined />, undefined, () => navigate('/import')),
        // getItem('Types', getKey(), <UsbOutlined />, undefined, () => navigate('/types')),
        getItem('Models', getKey(), <TagOutlined />, undefined, () => navigate('/models')),
        getItem('Transform', getKey(), <SwapOutlined />, undefined, () => navigate('/transform')),
        getItem('Export', getKey(), <ExportOutlined />, undefined, () => navigate('/export')),
    ];
    return (<Sider collapsible collapsed={collapsed} onCollapse={value => setCollapsed(value)}>
        <div style={{
            height: "100px",
            margin: "16px",
        }}><LazyImage src="Transformer.png" alt="Logo" style={{ width: "100%" }} /></div>
        <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline" items={items} />
    </Sider>);
}
